/* src/app/system-utils/component-factory/component-factory-view.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=component-factory-view.component.css.map */
